import { isBefore } from 'date-fns';
import { useEffect, useRef, useState } from 'react';
import { Cookies } from 'react-cookie';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { toast, ToastContainer } from 'react-toastify';
import * as XLSX from 'xlsx';
import { ClearSession } from '../../Common/Common';
import { ExportData } from '../../Exports/Export';
import Loader from "../../Layout/Loader";
import UserTable from './UserTable';
import { useNavigate } from 'react-router-dom';
import Footer from '../../Layout/FooterComponent';

const cookies = new Cookies();

const UserForm = () => {
    const [edit, setEdit] = useState(false)
    const [isLoading, setIsLoading] = useState(false);
    const [ColoredRow, setColoredRow] = useState('');
    const [tableData, setTableData] = useState([])
    const [eventCodeDropdown, setEventCodeDropdown] = useState([])
    const [VenueCodeDropdown, setVenueCodeDropdown] = useState([])
    const [groupNameDropdown, setGroupNameDropdown] = useState([]);
    const [active, setActive] = useState(true);
    const [userCode, setUserCode] = useState({ value: 'System Generated' })
    const [groupNameValue, setGroupNameValue] = useState('');
    const [eventCodeValue, setEventValue] = useState('');
    const navigate = useNavigate()


    const [dateOfJoining, setDateOfJoining] = useState('');
    const [currentPageNo, setCurrentPageNo] = useState(1);
    const [filterList, setFilterList] = useState([]);
    const [SessionClear, SetSessionClear] = useState(false);

    const [filterData, setFilterData] = useState({
        SearchText: "",
        StartValue: "1",
        SearchFieldValue: "",
    })
    const [formData, setFormData] = useState({
        UserName: '',
        Password: '',
        Address: '',
        MobileNo: '',
        EmailId: '',
        PinCode: '',
        EventCode: '',
        VenueCode: '',
        City: '',
    });
    const inputRefs = useRef([]);


    const filterFutureDates = (date) => {
        return isBefore(date, new Date());
    }


    const Token = cookies.get('token')
    const LoginUserCode = cookies.get('loginUserCode')
    const Source = 'web';

    // Display data and GETDAT

    const getUserMasterData = async (CurrentPage) => {
        setIsLoading(true)
        let PageIndex = 1
        if (CurrentPage !== undefined && typeof (CurrentPage) !== "object") {
            PageIndex = CurrentPage;
            setCurrentPageNo(CurrentPage);
        }
        else {
            setCurrentPageNo(1);
        }
        const data = {
            ...filterData,
            Token: cookies.get('token'),
            LoginUserCode: cookies.get('loginUserCode'),
            Source: 'web',
            Type: 'S',
            PageIndex: `${PageIndex}`
        }
        await fetch('/api/User/ShowUserMaster', {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                "Content-Type": "application/json"
            }
        }
        ).then(async (response) => {
            let res = await response.json();
            if (res.status === "SUCCESS") {
                setTableData(res)
                setIsLoading(false)
                inputRefs.current[res.focus].focus()
            }
            else if (res.status === "EXPIRED") {
                SetSessionClear(true);
            }
            else if (res.status === "ERROR") {
                toast.error(res.message, {
                   
                })
                setIsLoading(false)
                setTableData(res)
            }
        }).catch((err) => {
            toast.error(err.message, {
                position: 'top-center'
            })
            setIsLoading(false)
        }, [filterData])

    }

    const handleChange = (event) => {
        const { name, value } = event.target;
        setFormData((prevformdata) => ({ ...prevformdata, [name]: value }));
        validatePassword(formData.Password);
    }

    const validatePassword = (password) => {
        const regex = /^(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,15})/;
        return regex.test(password);
    };

    const handleClear = () => {
        setFormData({
            UserName: '',
            EventCode: '',
            VenueCode: '',
            Password: '',
            Address: '',
            MobileNo: '',
            EmailId: '',
            PinCode: '',

            City: '',
        });
        filterData.SearchText = '';
        setUserCode({ ...userCode, value: 'System Generated' });
        setActive(true);
        setDateOfJoining('')
        setGroupNameValue('')
        setEventValue('')
        getUserMasterData();
        setEdit(false)
        setColoredRow(null)
    }
    const EventDropdownList = async () => {


        let data = { Token, LoginUserCode }
        await fetch('/api/MasterController/GetEvent',
            {
                method: 'POST',
                body: JSON.stringify(data),
                headers: {
                    "Content-Type": "application/json"
                }
            }).then(async (response) => {
                let res = await response.json()
                setEventCodeDropdown(res.eventList);
            }).catch((err) => console.log(err));

    };

    const VenueDropdownList = async (eventCode) => {
        let data = {
            Token, LoginUserCode, eventCode, Type: 'GetVenue'
        }
        await fetch('/api/MasterController/GetVenue',
            {
                method: 'POST',
                body: JSON.stringify(data),
                headers: {
                    "Content-Type": "application/json"
                }
            }).then(async (response) => {
                let res = await response.json()
                setVenueCodeDropdown(res.venueList);
            }).catch((err) => console.log(err));

    };
    const userGroupDropdownList = async () => {
        let Condition = "";
        let TextPart = "UserGroupName"
        let ValuePart = "UserGroupID"
        let TableName = "UserGroupMaster"
        let data = { Token, LoginUserCode, Source, Condition, TextPart, ValuePart, TableName }
        await fetch('/api/User/BindDropDownList',
            {
                method: 'POST',
                body: JSON.stringify(data),
                headers: {
                    "Content-Type": "application/json"
                }
            }).then(async (response) => {
                let res = await response.json()
                if (res.status === "SUCCESS") {
                    setGroupNameDropdown(res.dropDownList);
                }
                else if (res.message === "EXPIRED") {
                    navigate("/login")
                    SetSessionClear(true);
                }
                else if (res.message !== "") {
                    toast.error(res.message, {
                       
                    })
                }

            }).catch((err) =>
                toast.error(err.message, {
                    position: 'top-center'
                })
            );

    };

    const handleSubmit = async () => {
        setIsLoading(true)
        let data = {
            ...formData, Token, LoginUserCode, Source, DateofJoining: document.getElementById('txtDOJ').value, UserCode: userCode.value,
            GroupName: groupNameValue,
            Active: active,
        }
        await fetch(`/api/User/InsertUpdateUserMaster`, {
            method: "POST",
            body: JSON.stringify(data),
            headers: {
                "Content-Type": "application/json"
            }
        }).then(async (response) => {
            let res = await response.json()
            if (res.status === 'SUCCESS') {
                setIsLoading(false);
                toast.success(res.message, {
                  
                })
                handleClear();
                setColoredRow(null)
                setEdit(false);
                getUserMasterData();
            }
            else if (res.message === "EXPIRED") {
                navigate("/login")
                SetSessionClear(true);
            }
            else if (res.message !== "") {
                toast.error(res.message, {
                    
                })
                inputRefs.current[res.focus].focus()
            }
            setIsLoading(false);
        }).catch((err) => {
            toast.error(err.message, {
              
            })
            setIsLoading(false)
        })
    };

    const handleEditData = async (id) => {
        const data = {
            Token: await cookies.get('token'),
            LoginUserCode: await cookies.get('loginUserCode'),
            Source: 'web',
            UserID: id
        }
        await fetch(`/api/User/EditUserMaster`, {
            method: "POST",
            body: JSON.stringify(data),
            headers: {
                "Content-Type": "application/json"
            }
        }).then(async (response) => {
            await setEdit(true)
            let res = await response.json()
            if (res.status === 'SUCCESS') {
                await setUserCode({ ...userCode, value: res.userCode })
                await setFormData({ ...formData, UserName: res.userName, Password: res.password, MobileNo: res.mobileNo, EmailId: res.emailID, Address: res.address, PinCode: res.pinCode, City: res.city, EventCode: res.event, VenueCode: res.venue });
                await setGroupNameValue(res.groupName);
                await VenueDropdownList(res.event)
                await setDateOfJoining(res.dateofJoining !== '' ? new Date(res.dateofJoining) : '');

                await setActive(res.active);
                setColoredRow(id)
              
            }
            else if (res.message === "EXPIRED") {
                navigate("/login")
                SetSessionClear(true);
            }
            else if (res.message !== "") {
                toast.error(res.message, {
                    position: 'top-center'
                })
                inputRefs.current[res.focus].focus()

            }
        }).catch((err) => {
            toast.success(err.message, {
                position: 'top-center'
            })
        })
    }

    const getSearchingList = async () => {
        let data = {
            Token, LoginUserCode, PageName: 'UserMaster'
        }
        await fetch('/api/DashboardController/BindSearchingColumnList', {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                "Content-Type": "application/json"
            }
        }).then(async (response) => {
            let res = await response.json()
            if (res.status === 'SUCCESS') {
                let list = res.getSearchingList
                setFilterData({ ...filterData, SearchFieldValue: list[0].searchingValue })
                setFilterList(res.getSearchingList)
            }
            else if (res.message === "EXPIRED") {
                navigate("/login")
                SetSessionClear(true);
            }
            else if (res.message !== "") {
                toast.error(res.message, {
                    
                })
                inputRefs.current[res.focus].focus()
                inputRefs.current[res.focus].children[0].children[0].focus()

            }
        }).catch((err) => {
            toast.error(err.message, {
               
            })
        })
    };

    const handleChange1 = (event, value) => {
        getUserMasterData(value);
    };

    const downloadExcel = (records) => {
        const workbook = XLSX.utils.book_new();
        const worksheet = XLSX.utils.aoa_to_sheet([
            [records.hSrNo, records.hUserCode, records.hUserName, records.hGroupName, records.hEmailID,
            records.hMobileNo, records.hDateOfJoining,
            records.hAddress, records.hCity,
            records.hPinCode,
            records.hActive, records.hCreatedBy, records.hCreatedDate, records.hCreatedByIPAddress, records.hModifiedBy, records.hModifiedDate, records.hModifiedByIPAddress, records.hEvent, records.hVenue]
            ,
            ...records.getUserMasterData?.map((records) => [records.srNo, records.userCode, records.userName, records.groupName, records.emailID,
            records.mobileNo, records.dateofJoining,
            records.address, records.city,
            records.pinCode,
            records.active, records.createdBy, records.createdDate, records.createdByIPAddress, records.modifiedBy, records.modifiedDate, records.modifiedByIPAddress, records.event, records.venue
            ]),
        ]);
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet 1');
        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        saveExcelFile(excelBuffer, 'UserMaster.xlsx');
    };

    const saveExcelFile = (buffer, fileName) => {
        const data = new Blob([buffer], { type: 'application/octet-stream' });
        const url = window.URL.createObjectURL(data);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
    };

    const handleDownloadExcel = async () => {
        const apiUrl = `/api/User/ShowUserMaster`;
        const requestBody = {
            ...filterData,
            Token: cookies.get('token'),
            LoginUserCode: cookies.get('loginUserCode'),
            Type: 'E',
            PageIndex: '1'
        }
        const requestHeaders = {
            'Content-Type': 'application/json',
        };
        const records = await ExportData(apiUrl, requestBody, requestHeaders);
        if (records) {
            downloadExcel(records);
        }
    };

    useEffect(() => {
        userGroupDropdownList();
        getSearchingList();
        EventDropdownList();
        getUserMasterData();
        document.title = 'User Master'
    }, []);

    return (
        <>
            <section className="section dashboard">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="content-box">
                            <div className="heading-box">
                                <div className="heading">
                                    <h6 className="m-0 font-weight-bold text-primary">{'User Master'}</h6>
                                </div>
                            </div>
                            <div className="form-box service-content-area">
                                <div className="row align-items-end">
                                    <div className="col-lg-3 col-md-4 col-sm-6">
                                        <div className="fields">
                                            <label className="form-label">User Code<span className="Required">*</span></label>
                                            <input

                                                type="text"

                                                className="form-control"
                                                placeholder='System Generated'
                                                name='UserCode'
                                                value={userCode.value}
                                                disabled
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-4 col-sm-6">
                                        <div className="fields">
                                            <label className="form-label">User Name <span className="Required">*</span></label>
                                            <input
                                                ref={ref => (inputRefs.current['txtUserName'] = ref)}
                                                type="text"
                                                className="form-control"
                                                placeholder="User Name"
                                                autoComplete="off"
                                                maxLength='30'
                                                id='txtUserName'
                                                name='UserName'
                                                value={formData.UserName}
                                                onChange={handleChange}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        inputRefs.current['txtPassword'].focus();
                                                    };
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-4 col-sm-6">
                                        <div className="fields">
                                            <label className="form-label">Password <span className="Required">*</span></label>
                                            <input
                                                ref={ref => (inputRefs.current['txtPassword'] = ref)}
                                                type="password"
                                                className="form-control"
                                                placeholder="Password"
                                                autoComplete="off"
                                                maxLength='15'
                                                minLength='8'
                                                name='Password'
                                                disabled={edit}
                                                value={formData.Password}
                                                onChange={handleChange}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        inputRefs.current['txtGroupName'].focus();
                                                    };
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-4 col-sm-6">
                                        <div className="fields">
                                            <label className="form-label">Group Name <span className="Required">*</span></label>
                                            <select
                                                ref={ref => (inputRefs.current['txtGroupName'] = ref)}
                                                id="inputState"
                                                className="form-select"
                                                value={groupNameValue}
                                                onChange={(e) => {
                                                    let value = e.target.value;
                                                    setGroupNameValue(value);
                                                    if (value === '1' || value === '2') {
                                                        setFormData({ ...formData, EventCode: '', VenueCode: '' })
                                                    }
                                                }}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        inputRefs.current['txtMobileNo'].focus();
                                                    };
                                                }}
                                            >
                                                <option>Choose Group Name</option>
                                                {
                                                    groupNameDropdown?.map((item, index) => {
                                                        return (
                                                            <option key={index} value={item.valuePart}>{item.textPart}</option>
                                                        )
                                                    })
                                                }
                                            </select>
                                        </div>
                                    </div>

                                    <div className="col-lg-3 col-md-4 col-sm-6">
                                        <div className="fields">
                                            <label className="form-label">Mobile Number<span className="Required">*</span></label>
                                            <input
                                                ref={ref => (inputRefs.current['txtMobileNo'] = ref)}
                                                type="tel"
                                                className="form-control"
                                                placeholder="Mobile Number"
                                                autoComplete="off"
                                                maxLength='15'
                                                name='MobileNo'
                                                value={formData.MobileNo}
                                                onChange={(e) => {
                                                    let { value } = e.target
                                                    const mobileNo = value.replace(/[^0-9]/g, '')
                                                    setFormData({ ...formData, MobileNo: mobileNo })
                                                }}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        inputRefs.current['txtEmailID'].focus();
                                                    };
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-4 col-sm-6">
                                        <div className="fields">
                                            <label className="form-label">Email ID <span className="Required">*</span></label>
                                            <input
                                                ref={ref => (inputRefs.current['txtEmailID'] = ref)}
                                                type="email"
                                                className="form-control"
                                                placeholder="Email ID"
                                                autoComplete="off"
                                                maxLength='50'
                                                name='EmailId'
                                                value={formData.EmailId}
                                                onChange={handleChange}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        inputRefs.current['txtAddress'].focus();
                                                    };
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-4 col-sm-6">
                                        <div className="fields">
                                            <label className="form-label">Address </label>
                                            <input
                                                ref={ref => (inputRefs.current['txtAddress'] = ref)}
                                                type="text"
                                                id="txtAddress"
                                                className="form-control"
                                                placeholder="Address"
                                                autoComplete="off"
                                                name='Address'
                                                maxLength='200'
                                                value={formData.Address}
                                                onChange={handleChange}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        inputRefs.current['txtPinCode'].focus();
                                                    };
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-4 col-sm-6">
                                        <div className="fields">
                                            <label className="form-label">PinCode <span className="Required">*</span></label>
                                            <input
                                                ref={ref => (inputRefs.current['txtPinCode'] = ref)}
                                                type="text"
                                                id="txtPinCode"
                                                className="form-control"
                                                placeholder="PinCode"
                                                autoComplete="off"
                                                name='PinCode'
                                                maxLength='10'
                                                value={formData.PinCode}
                                                onChange={handleChange}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        inputRefs.current['txtCity'].focus();
                                                    };
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-4 col-sm-6">
                                        <div className="fields">
                                            <label className="form-label">City <span className="Required">*</span></label>
                                            <input
                                                ref={ref => (inputRefs.current['txtCity'] = ref)}
                                                type="text"
                                                id="txtCity"
                                                className="form-control"
                                                placeholder="City"
                                                autoComplete="off"
                                                name='City'
                                                maxLength='50'
                                                value={formData.City}
                                                onChange={handleChange}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        inputRefs.current['txtDOJ'].input.focus();
                                                    };
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-4 col-sm-6">
                                        <div className="fields">
                                            <label className="form-label">Date of Joining</label>
                                            <DatePicker
                                                selected={dateOfJoining}
                                                ref={ref => (inputRefs.current['txtDOJ'] = ref)}
                                                id='txtDOJ'
                                                className="form-control"
                                                placeholderText='Date of Joining'
                                                dateFormat={'dd-MMM-yyyy'}
                                                autoComplete='off'
                                                onChange={(date) => setDateOfJoining(date)}
                                                filterDate={filterFutureDates}
                                                maxDate={new Date()}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        inputRefs.current['chkActive'].focus();
                                                    };
                                                }}
                                            />
                                        </div>
                                    </div>
                                    {groupNameValue === '3' || groupNameValue === '4' ?
                                        <div className="col-lg-3 col-md-4 col-sm-6">
                                            <div className="fields">
                                                <label className="form-label">Event  <span className="Required">*</span></label>
                                                <select
                                                    ref={ref => (inputRefs.current['txtEventCode'] = ref)}
                                                    id="inputState"
                                                    className="form-select"
                                                    value={formData.EventCode}
                                                    onChange={(e) => {
                                                        setFormData({ ...formData, EventCode: e.target.value })
                                                        VenueDropdownList(e.target.value)
                                                    }}
                                                    onKeyDown={(e) => {
                                                        if (e.key === 'Enter') {
                                                            inputRefs.current['txtVenueCode'].children[0].children[0].focus();
                                                        };
                                                    }}
                                                >
                                                    <option value=''>Please Select Event </option>
                                                    {
                                                        eventCodeDropdown?.map((item, index) => {
                                                            return (
                                                                <option key={index} value={item.eventCode}>{item.eventName}</option>
                                                            )
                                                        })
                                                    }

                                                </select>
                                            </div>
                                        </div>
                                        : <></>}

                                    {groupNameValue === '4' ?
                                        <div className="col-lg-3 col-md-4 col-sm-6">
                                            <div className="fields">
                                                <label className="form-label">Venue  <span className="Required">*</span></label>
                                                <select
                                                    ref={ref => (inputRefs.current['txtVenueCode'] = ref)}
                                                    id="inputState"
                                                    className="form-select"
                                                    value={formData.VenueCode}
                                                    onChange={(e) => {
                                                        setFormData({ ...formData, VenueCode: e.target.value })
                                                    }
                                                    }
                                                    onKeyDown={(e) => {
                                                        if (e.key === 'Enter') {
                                                            inputRefs.current['txtMobileNo'].children[0].children[0].focus();
                                                        };
                                                    }}
                                                >
                                                    <option value=''>Please Select Venue </option>
                                                    {
                                                        VenueCodeDropdown?.map((item, index) => {
                                                            return (
                                                                <option key={index} value={item.venueCode}>{item.venueName}</option>
                                                            )
                                                        })
                                                    }


                                                </select>
                                            </div>
                                        </div>

                                        : <></>}
                                    <div className="col-lg-3 col-md-4 col-sm-6 ms-4 mt-4">
                                        <div className="form-check form-switch">
                                            <label
                                                className="form-check-label"
                                                htmlFor="activeCheckbox"
                                            >
                                                Active
                                            </label>
                                            <input
                                                ref={ref => (inputRefs.current['chkActive'] = ref)}
                                                className="form-check-input"
                                                type="checkbox"
                                                id="activeCheckbox"
                                                name='Active'
                                                checked={active}
                                                onChange={(e) => setActive(e.target.checked)}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        handleSubmit();
                                                    };
                                                }}
                                            />
                                        </div>
                                    </div>

                                    <div className="col-lg-12 mt-4">
                                        <div className="lms-new-button text-center">
                                            {edit ? (isLoading ? <button className="button save-btn btn-disable" disabled={isLoading} >
                                                Please wait...
                                            </button> : <button className="button save-btn" onClick={handleSubmit}>
                                                <i className="bi bi-check-lg" /> Update & Save
                                            </button>) : (isLoading ? <button className="button save-btn btn-disable" disabled={isLoading} >
                                                Please wait...
                                            </button> : <button className="button save-btn" onClick={handleSubmit}>
                                                <i className="bi bi-check-lg" /> Save
                                            </button>)}
                                            <button className="button export-btn" onClick={handleDownloadExcel}>
                                                <i className="bi bi-download" /> Export
                                            </button>
                                            <button className="button reset-btn" onClick={handleClear}>
                                                <i className="bi bi-arrow-clockwise" /> Reset
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <UserTable loading={isLoading} handleReset={handleClear} handleChange={handleChange1} setColoredRow={setColoredRow} ColoredRow={ColoredRow} currentPageNo={currentPageNo} filterList={filterList} filterData={filterData} setFilterData={setFilterData} tableData={tableData} getUserData={getUserMasterData} handleEditData={handleEditData} />
            <ToastContainer theme='colored' />
          
            {SessionClear ? <ClearSession /> : <></>}
            <Footer/>
        </>
    )
}
export default UserForm






